import React from "react";
import { useProfile, useWebSocketContext } from "@moonscape/shared";
import { SyncProgressBanner } from "./SyncProgressBanner";
import { EmailSpamBanner } from "./EmailSpamBanner";

/**
 * The screen's single alert bar slot.
 *
 * "One bar per screen" (docs/design/newia-web/Alerts.html): the shell may have
 * several things to say at once, so exactly one wins here, by tone —
 * problem > caution > live > notice. Everything else is demoted to a box by the
 * screen that owns it (the demo notice in Screen.tsx is the standing example).
 */
export const ShellAlert = ({ userId }: { userId?: string }) => {
  const { activeSyncs } = useWebSocketContext();
  const { profile } = useProfile();

  const syncing = Array.from(activeSyncs.values()).some(
    (sync: any) => sync?.status === "processing"
  );

  // live
  if (syncing) return <SyncProgressBanner userId={userId} />;
  // notice
  if (!profile?.isDemo) return <EmailSpamBanner />;
  return null;
};
